import { ref, watch, onMounted } from '@vue/composition-api';

export function useAutoPlay(callBack: (...arg: unknown[]) => void) {
    const curAutoPlay = ref(true);
    watch(curAutoPlay, val => {
        localStorage.setItem('autoplay', val ? '1' : '0');
        callBack(val);
    });
    onMounted(() => {
        curAutoPlay.value = localStorage.getItem('autoplay') !== '0';
    });
    return {
        curAutoPlay,
    };
}